import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import './ImpactStories.css';
import { impactStories } from '../data/impactStories';

const ImpactStories = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const scrollRef = useRef(null);

  const categories = ['All', 'Entrepreneurship & Innovation', 'Agriculture & Innovation', 'Healthcare & Leadership'];

  const filteredStories = activeCategory === 'All'
    ? impactStories
    : impactStories.filter(s => s.category === activeCategory);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 380;
      scrollRef.current.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="impact-stories-section">
      <div className="container">
        <div className="impact-stories__header">
          <div className="impact-stories__header-left">
            <span className="section-label">CHANGEMAKERS &amp; VOICES</span>
            <h2 className="impact-stories__title">
              Real People. Real Stories.<br />
              <em>Real African Change.</em>
            </h2>
            <p className="impact-stories__subtitle">
              Meet the young leaders, agri-entrepreneurs, and tech innovators transforming communities with YOCILAB’s ecosystem.
            </p>
          </div>
          <div className="impact-stories__header-right">
            <Link to="/impact-stories" className="btn btn-outline">
              View All Stories
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>
        </div>

        {/* Filter Chips */}
        <div className="impact-stories__categories">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`cat-chip ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Stories Horizontal / Grid Track */}
        <div className="impact-carousel-wrapper">
          <div className="impact-stories__grid" ref={scrollRef}>
            {filteredStories.map((story) => (
              <div key={story.id} className="story-card-v2">
                <div className="story-card-v2__img-wrap">
                  <img src={story.image} alt={story.name} className="story-card-v2__img" loading="lazy" />
                  <span className="story-card-v2__badge">{story.country}</span>
                </div>
                <div className="story-card-v2__body">
                  <span className="story-card-v2__category">{story.category}</span>
                  <h3 className="story-card-v2__name">{story.name}</h3>
                  <p className="story-card-v2__role">{story.role}</p>

                  {story.quote && (
                    <blockquote className="story-card-v2__quote">
                      "{story.quote.length > 120 ? `${story.quote.slice(0, 120)}...` : story.quote}"
                    </blockquote>
                  )}

                  <p className="story-card-v2__short">{story.shortStory}</p>

                  <div className="story-card-v2__footer">
                    <Link to={`/impact-story/${story.id}`} className="story-card-v2__link">
                      Read Full Story
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M2 7H12M12 7L8 3M12 7L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="impact-carousel__nav">
            <button
              type="button"
              className="carousel-arrow-btn"
              onClick={() => scroll(-1)}
              aria-label="Previous stories"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M15 18l-6-6 6-6"/>
              </svg>
            </button>
            <button
              type="button"
              className="carousel-arrow-btn"
              onClick={() => scroll(1)}
              aria-label="Next stories"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactStories;
